module.exports = __webpack_public_path__ + "media/images/responsive/fairs/event_detail/try_on_dress-4a0a3b37dda829dde51cd099761441d3.jpg";